import { Component, OnInit, Input } from '@angular/core';
import { LandownerPassthroughProgramNote } from "../../../../common/models/permit.model";
@Component({
    selector: 'display-note',
    templateUrl: './display-note.component.html',
    styleUrls: ['./display-note.component.scss', '../../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class DisplayNoteComponent implements OnInit {

    @Input() note: LandownerPassthroughProgramNote;

    constructor() { }

    ngOnInit() {
    }

}
